export const actionTypes = {
  REQUEST_START: 'CONTACTS.GEOCODING.REQUEST_START',
  REQUEST_SUCCESS: 'CONTACTS.GEOCODING.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'CONTACTS.GEOCODING.REQUEST_FAILURE',
};

export function startRequest(api, id, address) {
  return {
    type: actionTypes.REQUEST_START,
    payload: {
      api,
      id,
      address,
    },
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
